export type RenderedImageFormat = "png" | "jpeg";

export interface RenderedImage {
  blob: Blob;
  url: string;
  filename: string;
  outputType: RenderedImageFormat;
  generatedAt: number;
}

interface CreateRenderedImageOptions {
  generatedAt?: number;
  createObjectUrl?: (blob: Blob) => string;
}

export function createRenderedImage(
  blob: Blob,
  filename: string,
  outputType: RenderedImageFormat,
  options: CreateRenderedImageOptions = {}
): RenderedImage {
  return {
    blob,
    url: (options.createObjectUrl ?? URL.createObjectURL)(blob),
    filename,
    outputType,
    generatedAt: options.generatedAt ?? Date.now()
  };
}

export function revokeRenderedImage(renderedImage: RenderedImage | null): void {
  if (renderedImage) {
    URL.revokeObjectURL(renderedImage.url);
  }
}
